import { CalendarIcon } from '../icons';

export default function CalendarPlaceholder() {
  return (
    <div className="h-[288px] w-full flex flex-col items-center justify-center px-8 bg-gray-800">
      <CalendarIcon />
      <p className="text-sm leading-[17px] font-light text-center text-gray-500">
        Select the month you wish to travel
        <br /> to see the calendar☝️
      </p>
    </div>
  );
}
